import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import './DropdownMenu.scss';

function DropdownMenu({
  options, onChangeCallback, customClassName = '', customIdName = '', dynamicDefaultOption,
}) {
  if (!options) { return null; }

  const checkIfDynamicDefaultOptionExists = () => (
    // eslint-disable-next-line eqeqeq
    dynamicDefaultOption && options.some(({ value }) => value == dynamicDefaultOption)
  );

  const getDefaultValue = () => {
    // If `DropdownMenu` can be mounted/unmounted a few times we might need to store
    // updated version of the default value somewhere in parent state and reuse on new mount
    const isDynamicDefaultOptionExist = checkIfDynamicDefaultOptionExists();
    if (isDynamicDefaultOptionExist) {
      return dynamicDefaultOption;
    }

    // Otherwise check for the default value flag in options
    const defaultOption = options.find(({ isDefaultValue }) => isDefaultValue);
    return defaultOption?.value;
  };
  const defaultValue = getDefaultValue(options);

  return (
    <select
      id={customIdName}
      className={`mn_dropdownMenu ${customClassName}`}
      onChange={onChangeCallback}
      defaultValue={defaultValue}
    >
      {options.map(({ value, label, className = '' }) => (
        <option key={`${value}-${label}`} value={value} className={className}>
          {label}
        </option>
      ))}
    </select>
  );
}

export default (props) => <ComponentErrorBoundary><DropdownMenu {...props} /></ComponentErrorBoundary>;
